export const CAT = {
  Basic: 'Basic',
  Financial: 'Financial',
  Address: 'Address',
  Usage: 'Usage',
  Meter: 'Meter',
  Identifier: 'Identifier',
  LineItems: 'Line Items', // EXACT label used by the tab
  Custom: 'Custom',
  Technical: 'Technical',
  Other: 'Other',
} as const;

export type CatKey = keyof typeof CAT;